var __jsx = React.createElement;
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import Head from "next/head";
import { useStore } from "@dp/state";
import { observer } from "mobx-react-lite";
import i18next from "i18next";
var MakeARequestComp = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.PrivateDiningRequestFlow;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var MakeARequestPage = function MakeARequestPage() {
  var _store$common;
  var store = useStore();
  var brand = store === null || store === void 0 || (_store$common = store.common) === null || _store$common === void 0 || (_store$common = _store$common.appAttributes) === null || _store$common === void 0 || (_store$common = _store$common.concept) === null || _store$common === void 0 ? void 0 : _store$common.conceptCodeDesc;
  useEffect(function () {
    store === null || store === void 0 || store.initComponent("PrivateDining").then(function () {
      //
    });
  }, []);
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("text.private_dining.page.form.title", {
    defaultValue: "Request Form | Private Dining | ".concat(brand, " Restaurant")
  })), __jsx("meta", {
    name: "description",
    content: i18next.t("text.private_dining.page.form.metadescription", {
      defaultValue: "Reserve a private dining room for your special occasion or business meeting at ".concat(brand, " by completing an online request form.")
    })
  })), __jsx(MakeARequestComp, null));
};
MakeARequestPage.layout = PageLayout.NB_LAYOUT;
MakeARequestPage.layoutProps = {
  showJoinWaitListHeader: true,
  isPrivateDiningPage: true,
  analyticsData: {
    pageName: "private-dining make-a-request",
    pageType: "private-dining"
  }
};
export default observer(MakeARequestPage);